// Regras do filtro da tela "Agendamento de Leads".
// Funções puras para poder testar sem montar a tela.

export const DATA_MIN = "2000-01-01";
export const DATA_MAX = "2100-12-31";

export const FILTROS_VAZIOS = {
    reuniaoDe: "",
    reuniaoAte: "",
    agendamentoDe: "",
    agendamentoAte: "",
    tipoAgenda: "",
    cliente: null,
    assessor: null,
    statusAuditoria: "",
    statusConfirmacao: "",
    statusBriefing: "",
};

// Data do <input type="date"> (AAAA-MM-DD) com ano de 4 dígitos e dentro da faixa aceita.
// Vazio é válido (campo opcional). Aceita também "AAAA-MM-DD HH:MM:SS" vindo da API.
export function dataValida(valor) {
    if (!valor) return true;
    const texto = String(valor);
    if (!/^\d{4}-\d{2}-\d{2}/.test(texto)) return false;
    const dia = texto.slice(0, 10);
    return dia >= DATA_MIN && dia <= DATA_MAX;
}

// Devolve a primeira mensagem de erro, ou null se os filtros estão ok.
export function validarFiltros(f) {
    const datas = [
        ["reuniaoDe", "Reunião de"],
        ["reuniaoAte", "Reunião até"],
        ["agendamentoDe", "Agendamento de"],
        ["agendamentoAte", "Agendamento até"],
    ];
    for (const [campo, rotulo] of datas) {
        if (!dataValida(f[campo])) {
            return `Data inválida em "${rotulo}". Use um ano entre 2000 e 2100.`;
        }
    }
    if (f.reuniaoDe && f.reuniaoAte && f.reuniaoDe > f.reuniaoAte) {
        return "Na data da reunião, o início está depois do fim.";
    }
    if (f.agendamentoDe && f.agendamentoAte && f.agendamentoDe > f.agendamentoAte) {
        return "Na data do agendamento, o início está depois do fim.";
    }
    return null;
}

// Monta os parâmetros da chamada agendamento-lead/listing.
// Só envia o que foi preenchido: campo vazio = sem filtro.
export function montarParams(f, page, gridFilters, idAssessorLogado) {
    const params = {
        page: page + 1,
        pageSize: 50,
        data_reuniao_inicio: f.reuniaoDe,
        data_reuniao_fim: f.reuniaoAte,
        data_agendamento_inicio: f.agendamentoDe,
        data_agendamento_fim: f.agendamentoAte,
        tipo_agenda: f.tipoAgenda,
        cliente: f.cliente?.id,
        assessor: f.assessor?.id,
        status_auditoria: f.statusAuditoria,
        status_confirmacao: f.statusConfirmacao,
        enviou_briefing: f.statusBriefing,
        id_assessor: idAssessorLogado,
    };
    Object.keys(params).forEach((chave) => {
        const valor = params[chave];
        if (valor === undefined || valor === null || valor === "") {
            delete params[chave];
        }
    });
    if (Array.isArray(gridFilters) && gridFilters.length) {
        params.filters = gridFilters;
    }
    return params;
}
